
      // Le document est pré-rendu : on réserve le téléchargement React après
      // le premier affichage pour ne pas concurrencer le CSS, les polices et le LCP.
      const bootApplication = () => import("/src/main.jsx");
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(bootApplication, { timeout: 700 });
      } else {
        window.addEventListener("load", bootApplication, { once: true });
      }
    